_ = require 'underscore'
BaseDirectoryView = require './base-directory-view'
directoryLegacyPowerUps = require './directory-legacy-power-ups'
DirectoryPluginItemView = require './directory-plugin-item-view'
Format = require 'lib/markdown/format'
l = require 'lib/localize'
PluginIOCache = require 'views/internal/plugins/plugin-io-cache'
t = require('views/internal/recup-with-helpers')('directory')
powerUpItemDetailsT = require('views/internal/recup-with-helpers')('power_up_item_details')
React = require 'react'
xtend = require 'xtend'

class DirectoryListing extends React.Component
  displayName: 'Directory Listing'

  render: t.renderable ->
    { categories, description, displayName, isGrandfathered, onCategoryClick } = @props
    t.div '.directory-individual-listing', ->
      t.div '.js-directory-listing'
      t.div ->
        t.icon 'information', class: 'icon-lg'
        _.map categories, (category) ->
          t.a '.category-link', { href: '#', onClick: -> onCategoryClick(category) }, ->
            t.format category
      if isGrandfathered
        t.p '.power-up-grandfathered', ->
          powerUpItemDetailsT.format 'power-up-was-enabled-on-this-board-before-some-recent-changes-we-made', {
            name: displayName
          }
          t.text ' 🎉'
      t.div '.directory-listing-content.markeddown', ->
        t.raw Format.markdownAsHtml(description)

module.exports = class DirectoryListingView extends BaseDirectoryView
  className: 'directory-listing-wrapper'

  initialize: ({ @directoryView, @plugin, @currentPage }) ->
    super

    powerUp = _.findWhere directoryLegacyPowerUps, { id: @plugin.id }

    if powerUp
      name = powerUp.name
      @isGrandfathered = name in @model.get('powerUps')

  navigateToCategory: (category) ->
    @directoryView.navigate({ section: 'category', category })

  renderContent: ->
    io = PluginIOCache.get(@plugin)
    React.createElement DirectoryListing, {
      displayName: io.getName()
      description: io.getDescription()
      categories: @plugin.get('categories')
      isGrandfathered: @isGrandfathered
      onCategoryClick: (category) => @navigateToCategory(category)
    }

  render: ->
    super

    @appendSubview @subview(DirectoryPluginItemView, @model, {
      @plugin,
      @currentPage,
      @directoryView,
    }, @plugin.id),
    @$('.js-directory-listing')

    enabledPlugins = @directoryView.getEnabledPlugins()

    @directoryView.trackScreenEvent 'powerUpDetailsScreen',
      powerUpId: @plugin.id
      isEnabled: if _.some(enabledPlugins, { id: @plugin.id } ) then true else false

    @




// WEBPACK FOOTER //
// ./app/scripts/views/directory/directory-listing-view.coffee